import { FC } from 'react'
import { ReactComponent as AIListeningIcon } from 'src/assets/svg/ai-listening-disabled.svg'
import classes from './emptyState.module.scss'

interface EmptyStateProps {
  onEnableClick?: () => void
}

export const EmptyState: FC<EmptyStateProps> = ({ onEnableClick }) => {
  return (
    <div className={classes.disabledContent}>
      <div className={classes.disabledBody}>
        <div className={classes.disabledIconWrapper}>
          <AIListeningIcon />
        </div>
        <h2 className={classes.disabledTitle}>AI Listening is Disabled</h2>
        <p className={classes.disabledDescription}>
          Enable AI Listening to start tracking your brand across AI platforms
          and see insights on visibility and mentions.
        </p>
        <button
          className={classes.enableButton}
          onClick={onEnableClick}
          type="button"
        >
          Enable
        </button>
      </div>
    </div>
  )
}
